<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="job-det col-md-12 row">
                    <div class="col-md-4 col-sm-12">
                        <div class="j-main">
                            <div class="j-logo">
                                <img :src="application_detail.icon">
                            </div>
                            <div class="j-data">
                                <div class="j-title">
                                    <router-link :to="{path: '/detail?id=' + application_detail.slug}" target="_blank" v-html="application_detail.job_title"></router-link>
                                </div>

                                <div class="j-share">
                                    <span class="fbook">
                                        <a href="javascript:;" onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-facebook"></i>
                                        </a>
                                    </span>
                                    <span class="wts">
                                        <a href="javascript:;" onclick="window.open('https://api.whatsapp.com/send?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-whatsapp"></i>
                                        </a>
                                    </span>
                                    <span class="twt">
                                        <a href="javascript:;" onclick="window.open('https://twitter.com/intent/tweet?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </span>
                                    <span class="mail">
                                        <a href="javascript:;" onclick="window.open('mailto:?&amp;body=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fa fa-envelope"></i>
                                        </a>
                                    </span>
                                    <span class="link">
                                        <a href="javascript:;" onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&amp;url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                            <i class="fab fa-linkedin"></i>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="j-detail" v-if="application_detail.experience">
                            <div class="j-exp" style="margin-bottom: 22px;">
                                <div class="e-logo">
                                    <i class="far fa-clock"></i>
                                </div>
                                <div class="e-detail">
                                    <h1>Experience</h1>
                                    <p>{{ application_detail.experience }}</p>
                                </div>
                            </div>
                            <div class="j-exp loc" v-if="application_detail.applicationPlacementLocations">
                                <div class="e-logo">
                                    <i class="fas fa-map-marker-alt"></i>
                                </div>
                                <div class="e-detail">
                                    <h1>Locations</h1>
                                    <p class="list-data">
                                        <span v-for="pc in application_detail.applicationPlacementLocations">{{pc.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                        <div class="j-detail">
                            <div class="j-exp salry" style="margin-bottom: 22px;">
                                <div class="e-logo">
                                    <i class="far fa-money-bill-alt"></i>
                                </div>
                                <div class="e-detail">
                                    <h1>Offered Stipend</h1>
                                    <p v-if="application_detail.fixed_wage">{{ application_detail.fixed_wage }}</p>
                                    <p v-else-if="application_detail.min_wage || application_detail.max_wage"><span>{{application_detail.min_wage}}</span> <span v-if="application_detail.max_wage">to {{application_detail.max_wage}}</span> </p>
                                    <p v-else>Unpaid</p>
                                </div>
                            </div>
                        </div>
                        <div class="j-detail" v-if="application_detail.positions">
                            <div class="j-exp salry">
                                <div class="e-logo"><i class="fa fa-user-plus"></i></div>
                                <div class="e-detail">
                                    <h1>Openings</h1>
                                    <p>
                                        {{ application_detail.positions }} Openings </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <span class="stamp is-nope at-top" v-if="application_detail.is_closed">Recruitment Completed</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="process-main" class="container">
            <ul class="nav nav-tabs pr-process-tab" v-if="processesList.length">
                <li class="active" :style="'width:calc(100% /' + (processesList.length + 2) +')'">
                    <a data-filter="*" href="#">
                        All
                        <span>{{ total_count }}</span>
                    </a>
                </li>
                <li :style="'width:calc(100% /' + (processesList.length + 2) +')'" v-for="cp in processesList">
                    <a :data-filter="'.' + cp.field_enc_id" data-toggle="tooltip" data-placement="bottom"
                       :data-original-title="cp.field_name" href="javascript:;" class="tooltip-main">
                        <i :class="cp.icon" aria-hidden="true"></i>
                        <span>{{ cp.count }}</span>
                        <span class="tooltiptext tooltip-bottom">{{ cp.field_name }}</span>
                    </a>
                </li>
                <li :style="'width:calc(100% /' + (processesList.length + 2) +')'">
                    <a data-filter=".result" data-toggle="tooltip" data-placement="bottom" data-original-title="Hired"
                       href="javascript:;" class="tooltip-main">
                        <i class="far fa-check-square" aria-hidden="true"></i>
                        <span>{{ hired_count }}</span>
                        <span class="tooltiptext tooltip-bottom">Hired Candidates</span>
                    </a>
                </li>
            </ul>
            <ul class="hiring_process_list gallery_zoom">
                <li :class="getIdByProcess(cand)" v-for="cand in candidates" v-if="candidates.length">
                    <div class="row pr-user-main">
                        <div class="reject-box" style="display: flex;" v-if="cand.candidateRejections.length">
                            <router-link class="pr-user-n url-forward"
                                         :to="{path: '/dashboard/viewcandidates?id=' + cand.user_enc_id}">
                                <h4>{{ cand.name }}</h4>
                            </router-link>

                            <div class="rejectReason showRejection" style="display: flex">
                                <div class="sr-box">
                                    <p>This candidate has been rejected with below reasons</p>
                                    <div class="sr-jobs">
                                        <span class="reject-reason-list"
                                              v-for="rr in cand.candidateRejections[0].candidateRejectionReasons">{{ rr.reason }}</span>
                                        <!--                                    <a href="#" target="_blank">-->
                                        <!--                                    <div class="customJobBox">-->
                                        <!--                                        <div class="jc-icon">-->
                                        <!--                                            <img src="#">-->
                                        <!--                                        </div>-->
                                        <!--                                        <p>job_title</p>-->
                                        <!--                                    </div>-->
                                        <!--                                    </a>-->
                                        <!--                                    <p id="" class="cCount" style="display: block"> 2 More</p>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12 pr-user-inner-main">
                            <div class="col-md-4">
                                <div class="pr-user-detail">
                                    <router-link class="pr-user-icon"
                                                 :to="{path: '/dashboard/viewcandidates?id=' + cand.user_enc_id}">
                                        <img :src="cand.image">
                                    </router-link>
                                    <router-link :to="{path: '/dashboard/viewcandidates?id=' + cand.user_enc_id}">
                                        <h4>{{ cand.name }}</h4>
                                    </router-link>
                                    <br/><br/>
                                </div>
                                <div class="pr-user-past" v-if="cand.user_data.userEducations.length">
                                      <span class="past-title">
                                        Edu
                                      </span>
                                    <h5>{{ cand.user_data.userEducations[0].institute }} -
                                        {{ cand.user_data.userEducations[0].degree }}</h5>
                                    <span>+{{ cand.user_data.userEducations.length - 1 }} more</span>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="pr-user-skills">
                                    <ul v-if="cand.user_data.skill">
                                        <li v-for="sl in cand.user_data.skill">{{ sl }}</li>
                                    </ul>
                                    <h4 class="clamp-c" style="display: flex;align-items: center;" v-if="cand.appliedApplicationLocations.length">
                                        <span><i class="fas fa-map-marker-alt"></i> </span>
                                        <p class="list-data" style="margin: 5px;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;"><span v-for="ap in cand.appliedApplicationLocations">
                                                {{ap.city_name}}
                                            </span></p>
                                        <div class="all-data">
                                            <h5 class="list-data"><span v-for="ap in cand.appliedApplicationLocations">
                                                {{ap.city_name}}
                                            </span> </h5>
                                        </div>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div class="pr-user-action-main">
                            <div class="pr-full-height">
                                <a href="javascript:;">
                                    <img src="/images/dashboard/cbc.png" v-if="cand.status == 'Cancelled'"/>
                                    <img src="/images/dashboard/rejectedc.png" v-else-if="cand.status == 'Rejected'"/>
                                    <img src="/images/dashboard/hiredc.png" v-else-if="cand.status == 'Hired'"/>
                                    <img src="/images/dashboard/in_progress.png" v-else/>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
    data() {
        return {
            processesList: [],
            candidates: [],
            total_count: '',
            hired_count: '',
            application_detail: [],
        }
    },
    mounted() {
        if (!document.getElementById('my-isotope')) {
            var scriptTag = document.createElement("script");
            scriptTag.src = "https://unpkg.com/isotope-layout@3/dist/isotope.pkgd.min.js";
            scriptTag.id = "my-isotope";
            document.getElementsByTagName('head')[0].appendChild(scriptTag);
        }
        var t = this;
        setTimeout(function () {
            t.hiringProcess();
        }, 2000);
        this.getProcesses();
    },
    methods: {
        hiringProcess() {
            // if (jQuery().isotope) {
            // Needed variables
            var list = $('.hiring_process_list');
            var filter = $('.pr-process-tab li');

            if (filter.length) {
                // Isotope Filter
                filter.find('a').on('click', function () {
                    var selector = $(this).attr('data-filter');
                    list.isotope({
                        filter: selector,
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });

                    return false;
                });

                // Change active element class
                filter.find('a').on('click', function () {
                    filter.find('a').parent().removeClass('active');
                    $(this).parent().addClass('active');
                    return false;
                });
                // }
            }
        },
        getProcesses: function (event) {
            var t = this;
            var slug = this.$route.query.id;
            var url = this.$store.getters.getDomain;

            axios({
                method: 'POST',
                url: `${url}api/v2/college-profile/candidates-process`,
                data: {slug: slug},
                headers: requestHeaders()
            })
                .then(function (response) {
                    if (response['data']['response']['data'].length) {
                        t.application_detail = response['data']['response']['application_detail'];
                        t.processesList = response['data']['response']['process'];
                        t.candidates = response['data']['response']['data'];
                        t.hired_count = response['data']['response'].hired_count;
                        t.total_count = response['data']['response'].total_count;
                    } else {
                        alert('No Candidates Found');
                        t.$router.go(-1);
                    }
                })
                .catch(function (error) {
                    // console.log(error)
                })
        },
        getIdByProcess(e) {
            var currentRouond = parseInt(e.active);
            if (e.appliedApplicationProcesses.length) {
                if (e.appliedApplicationProcesses.length > currentRouond) {
                    return e.appliedApplicationProcesses[currentRouond].field_enc_id;
                } else if (e.appliedApplicationProcesses.length == currentRouond) {
                    return 'result';
                }
            }
            return "";
        }
    }
}
</script>

<style scoped>
li {
    list-style: none;
}

.pr-user-main {
    margin: 60px 0px;
    margin-bottom: 0px;
    border-radius: 8px;
    box-shadow: 0px 3px 10px 2px #ddd;
    background-color: #fdfdfd;
    width: 100%;
    position: relative;
}

.pr-user-inner-main {
    padding: 20px 0px;
    padding-top: 0px;
    padding: ;
    adding-left: 15px;
    width: calc(100% - 70px);
}

.hiring_process_list > li {
    width: 100%;
}

.pr-user-detail h4 {
    font-size: 19px;
    font-weight: 500;
    margin: 0px;
    display: inline-block;
}

.pr-user-detail {
    padding-left: 85px;
    padding-top: 20px;
    margin-top: -10px;
    margin-bottom: 30px;
}

.pr-user-icon {
    display: inline-block;
    width: 90px;
    height: 90px;
    transform: translate(0px, -45px);
    border: 5px solid #fff;
    box-shadow: 0px 0px 10px 0px #ddd;
    border-radius: 4px;
    position: absolute;
    left: 0;
    z-index: 9;
}

.pr-user-icon img {
    width: 100%;
    height: 100%;
}

.pr-user-detail h5 {
    font-size: 14px;
    font-weight: 500;
    margin: 8px 0px;
    color: #858585;
}

.pr-user-detail h4 span {
    font-size: 14px;
    color: #777777;
}

.pr-user-past span {
    display: inline-block;
    color: #aaa;
}

.pr-user-past .past-title {
    background-color: #f2f2f2;
    color: #555;
    padding: 3px 15px;
    border-radius: 20px;
}

.pr-user-past h5 {
    display: inline-block;
}

.pr-user-skills {
    padding-top: 20px;
}

.pr-user-skills ul, .pr-user-actions ul {
    list-style: none;
    padding: 0px;
}

.pr-user-skills ul li {
    display: inline-block;
    background-color: #efefef;
    padding: 4px 15px;
    margin: 2px;
    font-size: 15px;
    color: #222;
    border-radius: 30px;
}

.pr-user-skills h4 {
    font-size: 14px;
}

.pr-user-skills h4 span {
    color: #777;
}

.pr-user-actions ul {
    padding-top: 40px;
    text-align: right;
}

.pr-user-actions ul li {
    display: inline-block;
    font-size: 23px;
    margin: 0px 8px;
}

.pr-user-actions ul li a img {
    max-width: 35px;
}

.pr-user-action-main {
    width: 70px;
    float: right;
    height: 165px;
    display: block;
    position: relative;
    border-left: 1px solid #ddd;
}

.pr-full-height {
    position: relative;
    height: 100%;
}

.pr-full-height a img {
    position: absolute;
    width: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Tabs css starts*/
.pr-process-tab {
    border-bottom: none;
}

.pr-process-tab li {
    display: block;
    float: left;
    position: relative;
    font-size: 1.25em;
    line-height: 1.5em;
    text-align: center;
    text-overflow: ellipsis;
    background: white;
    border: 1px solid #ccc;
    border-right: none;
    padding: 0;
    cursor: pointer;
    margin-bottom: 1em;
    color: #555;
}

.pr-process-tab li a {
    background-color: transparent !Important;
    color: #555 !Important;
    border: none !Important;
    padding: 7.5px 15px;
    font-size: 13px;
}

.pr-process-tab li a:hover {
    background-color: transparent;
}

.pr-process-tab li.active a {
    color: #fff !important;
}

.pr-process-tab li:before {
    content: "";
    display: block;
    position: absolute;
    z-index: 1;
    top: 0;
    right: -34px;
    width: 0;
    height: 0;
    border: 17px solid transparent;
    border-left-color: #797979;
}

.pr-process-tab li:after {
    content: "";
    display: block;
    position: absolute;
    z-index: 1;
    top: 0;
    right: -35px;
    margin-right: 1px;
    width: 0;
    height: 0;
    border: 17px solid transparent;
    border-left-color: white;
}

.pr-process-tab li:first-child {
    border-radius: 20px 0 0 20px;
}

.pr-process-tab li:last-child {
    border-right: 1px solid #ccc;
    border-radius: 0 20px 20px 0;
}

.pr-process-tab li:last-child:before, .pr-process-tab li:last-child:after {
    display: none;
}

.pr-process-tab li:hover {
    background: #eee;
}

.pr-process-tab li:hover:after {
    border-left-color: #eee;
}

.pr-process-tab li.active {
    background: #00a0e3;
    border-color: #00a0e3;
}

.pr-process-tab li.active:after {
    border-left-color: #00a0e3;
}

.pr-process-tab li.active:before {
    border-left-color: #00a0e3;
}

.hiring_process_list {
    padding-left: 0px;
}

/* Tabs css ends*/

@media screen and (max-width: 600px) {
    .pr-user-inner-main {
        width: 100%;
    }

    .pr-user-actions ul {
        text-align: center;
    }

    .pr-user-action-main {
        width: 100%;
        border-top: 1px solid #ddd;
        border-left: 0px;
        height: 75px;
    }

    .nav.nav-tabs li {
        width: 100%;
        margin-bottom: 0px;
        border-bottom: 0px;
        border-right: 1px solid #ddd;
    }

    .pr-process-tab li:first-child {
        border-radius: 0px;
    }

    .pr-process-tab li:before {
        top: 34px;
        right: 2%;
        transform: rotateZ(90deg);
    }

    .pr-process-tab li:after {
        top: 34px;
        right: 2%;
        margin-right: 0px;
        transform: rotateZ(90deg);
    }

    .pr-process-tab li:last-child {
        border-bottom: 1px solid #ccc !important;
        border-radius: 0px;
    }
}

.reject-box .pr-user-n {
    margin-top: 55px;
    flex-basis: 15%;
}

.h100 {
    height: 100%;
}

.showRejection {
    display: none;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.sr-box {
    color: #000;
}

.reject-box {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 102%;
    background: rgba(255, 255, 255, .96);
    z-index: 9;
    border-radius: 8px;
    padding: 10px 15px;
}

.rejectReason p {
    text-align: center;
    font-family: lora;
    font-size: 20px;
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 5px;
    color: #333;
}

.customJobBox p {
    color: #333 !important;
    font-size: 16px;
    margin-bottom: 0px;
    margin-top: 0px;
    font-family: Roboto !important;
    font-weight: 500 !important;
}

.rejectReason {
    text-align: center;
    width: 100%;
}

.rejectReason ul {
    padding-inline-start: 0px;
}

.rejectReason ul li {
    display: inline-block;
    padding: 5px;
}

.suggestJob input {
    position: absolute;
    visibility: hidden;
}

.pr-process-tab li a span {
    padding: 3px 8px;
    font-weight: bold;
}

.jc-icon {
    width: 50px;
    height: 50px;
}

.jc-icon img {
    width: 100%;
    height: 100%;
}

.reject-reason-list {
    background-color: #00a0e3;
    color: #fff;
    padding: 10px 15px;
    margin: 10px 5px;
    display: inline-block;
    border-radius: 20px;
}
.job-det.col-md-12 {
    box-shadow: 0px 3px 10px 2px #ddd;
    margin: 30px 0;
    padding: 25px 15px;
    background: #fdfdfd;
}
.j-main {
    display: flex;
    border-right: 2px solid #333;
    align-items: center;
}
.j-logo {
    width: 85px;
    height: 85px;
}
.j-logo img {
    width: 85px;
    height: 85px;
    object-fit: contain;
}
.j-data {
    margin-left: 15px;
    text-align: center;
}
.j-title {
    font-size: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
}
.j-title a {
    color: #333;
    font-family: roboto;
    text-transform: capitalize;
}
.j-share span {
    margin: 0 5px;
}
.fbook a {
    color: #4267B2;
}
.wts a {
    color: #00bf8f;
}
.twt a {
    color: #00aced;
}
.mail a {
    color: #b00;
}
.link a {
    color: #007bb6;
}
.j-exp {
    display: flex;
}
.e-logo {
    width: 30px;
    text-align: right;
    margin-right: 10px;
}
.e-detail h1 {
    margin: 0;
    font-size: 16px;
    font-family: roboto;
    font-weight: 400;
    line-height: 22px;
}
.e-detail p {
    margin: 0;
    font-size: 11px;
    height: 15px;
}
.e-logo i {
    font-size: 22px;
    color: #00a0e3;
    margin-top: 8px;
}
.all-data {
    position: absolute;
    background-color: #fff;
    display: none;
    border-radius:4px;
    padding:8px 15px;
    top: 30px;
    box-shadow:0px 1px 6px 2px #ddd;
    z-index:9;
}
.all-data:before {
    content: "";
    left: 12px;
    top: -18px;
    position: absolute;
    border-top: 10px solid transparent;
    border-right: 15px solid #00A0E3;
    border-bottom: 10px solid transparent;
    transform: rotate(90deg);
}
.clamp-c:hover .all-data {
    display: block;
}
.clamp-c{
    position: relative;
}
</style>